import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { inject } from '@angular/core';
import { AUTH_SESSION } from '@shared/di/auth-session.token';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const session = inject(AUTH_SESSION);
  return session.accessToken$.pipe(take(1), switchMap((token) => {
    const headers: Record<string, string> = { 'x-timezone': timezone };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return next(req.clone({ setHeaders: headers }));
  }));
}
